import { render, staticRenderFns } from "./OffMarketRegistration.vue?vue&type=template&id=13489ff2&scoped=true&"
import script from "./OffMarketRegistration.vue?vue&type=script&lang=ts&"
export * from "./OffMarketRegistration.vue?vue&type=script&lang=ts&"
import style0 from "./OffMarketRegistration.vue?vue&type=style&index=0&id=13489ff2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13489ff2",
  null
  
)

export default component.exports